import { MERGE_ACCOUNTS } from '@/shared/config/routes';

export function getAuthRedirectUrls(searchParams: URLSearchParams): {
  redirect_url: string;
  merge_redirect_url: string;
} {
  const from = searchParams.get('next');
  let redirect_url = window.location.origin;

  if (from) {
    redirect_url += from.startsWith('/') ? from : `/${from}`;
  } else {
    redirect_url += '/';
  }

  return {
    redirect_url,
    merge_redirect_url: `${window.location.origin}${MERGE_ACCOUNTS}?redirect_url=${encodeURIComponent(redirect_url)}`,
  };
}